import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../services/AuthContext";
import { editUserProfile, fetchUserData } from "../../services/UserServices";
import { Button, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import ShippingData from "../../components/ShippingData";
import useValidation from "../../services/useValidation";
import AutoDismissAlert from "../../components/AutoDismissAlert";

export default function UserProfileData() {
  const { user } = useContext(AuthContext);
  const [userData, setUserData] = useState({});
  const [validated, setValidated] = useState(false);
  const [ shippingData, setShippingData ] = useState({province_id: 0});
  const [loading, setLoading] = useState(false);
  const phoneValidation = useValidation('','phone');
  const emailValidation = useValidation('','email');
  const [variantMessage, setVariantMessage] = useState('');
  const [visibleMessage, setVisibleMessage] = useState(false);
  const [message, setMessage] = useState('');
  

  const handleSubmit = (event) => {
    const form = event.currentTarget
    event.preventDefault()
    if (form.checkValidity() === false) {
      event.stopPropagation()
    } else {
      saveUser();
    }
    setValidated(true)
  }
  
  useEffect(()=>{
    const tp = user.isSeller ? 'v' : '';
    fetchUserData(user.id,tp)
      .then((data)=>{
        setUserData(data);
        emailValidation.setValue(data.email);
        phoneValidation.setValue(data.telefono);
      })
  },[user])

  const saveUser = async () => {
    var f = new FormData();
    f.append("nombre", userData.nombre);
    f.append("apellido", userData.apellido);
    f.append("telefono", phoneValidation.value);
    f.append("provincia_id", shippingData.province_id);
    f.append("fecha_nacimiento", userData.fecha_nacimiento);
    f.append("ciudad_id", shippingData.city_id);
    f.append("isSeller", user.isSeller);
    if (userData.cuit) {
      f.append("cuit", userData.cuit)
    }
    if (shippingData.direccion) {
      f.append("direccion", shippingData.direccion)
    }
    if (shippingData.transporte) {
      f.append("transporte", shippingData.transporte)
    }

    setLoading(true);
    editUserProfile(user.id, f)
      .then((data)=>{
        setVariantMessage('success');
        setVisibleMessage(true);
        setMessage('Los datos se han guardado correctamente');
      })
      .catch((err)=>{
        setVariantMessage('danger');
        setVisibleMessage(true);
        setMessage(err.response.data);
      })
      .finally(()=>{setLoading(false)})
  }

  const handleCuitChange = (e) => {
   let value = e.target.value.replace(/\D/g, ''); // Elimina todo lo que no sea número
    
    // Aplicar formato: 00-00000000-0
    if (value.length > 2 && value.length <= 10) {
      value = `${value.slice(0, 2)}-${value.slice(2)}`;
    } else if (value.length > 10) {
      value = `${value.slice(0, 2)}-${value.slice(2, 10)}-${value.slice(10, 11)}`;
    }

    setUserData(prev => ({
      ...prev,
      cuit: value
    }));
  }

  return (
    <div>
      {visibleMessage && 
        <AutoDismissAlert
          variant={variantMessage}
          message={message}
          duration={4000}
          show={visibleMessage} 
          onClose={() => setVisibleMessage(false)} />
      }
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row>
          <Form.Group as={Col} controlId="formName">
            <FloatingLabel controlId="floatingName" label="Nombre">
              <Form.Control
                type="text"
                placeholder="Nombre"
                value={userData.nombre || ''}
                onChange={(e)=>{
                  setUserData({
                    ...userData,
                    nombre: e.target.value
                  })
                }}
                required
              />
              <Form.Control.Feedback type="invalid">
                Debe ingresar un nombre.
              </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} controlId="formLastname">
            <FloatingLabel controlId="floatingLastname" label="Apellido">
              <Form.Control
                type="text"
                placeholder="Apellido"
                value={userData.apellido || ''}
                onChange={(e)=>{
                  setUserData({
                    ...userData,
                    apellido: e.target.value
                  })
                }}
                required
              />
              <Form.Control.Feedback type="invalid">
                Debe ingresar un apellido.
              </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>
        </Row>
        <Row className="mt-3">
          <Form.Group as={Col} controlId="formCuit">
            <FloatingLabel controlId="floatingCuit" label="Cuit">
              <Form.Control
                type="text"
                placeholder="Cuit"
                value={userData.cuit}
                onChange={handleCuitChange}
              />
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} controlId="formBirthDate">
            <FloatingLabel controlId="floatingBirthDate" label="Fecha de Cumpleaños">
              <Form.Control
                type="date"
                placeholder="Fecha de Cumpleaños"
                value={userData.fecha_nacimiento || ''}
                onChange={(e)=>{
                  setUserData({
                    ...userData,
                    fecha_nacimiento: e.target.value
                  })
                }}
              />
            </FloatingLabel>
          </Form.Group>
        </Row>
        <Row className="mt-3">
          <Form.Group as={Col} controlId="formGridEmail">
            <FloatingLabel controlId="floatingEmail" label="E-mail">
              <Form.Control
                type="email"
                placeholder="E-mail"
                disabled
                value={emailValidation.value}
                onChange={emailValidation.handleChange}
                isInvalid={!emailValidation.isValid}
                required
              />
              <Form.Control.Feedback type="invalid">
                {emailValidation.errorMessage !== '' ? emailValidation.errorMessage : "Debe ingresar el e-mail"}
              </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} controlId="formGridPhone">
            <FloatingLabel
              controlId="floatingPhone"
              label="Teléfono/WhatsApp"
              className="mb-3"
            >
              <Form.Control 
                type="number"
                placeholder='Teléfono/WhatsApp'
                value={phoneValidation.value}
                onChange={phoneValidation.handleChange}
                isInvalid={!phoneValidation.isValid}
                required/>
              <Form.Control.Feedback type="invalid">
                {phoneValidation.errorMessage !== '' ? phoneValidation.errorMessage : "Debe ingresar el teléfono"}
              </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>

          {/* <Form.Group as={Col} controlId="formPhone">
            <FloatingLabel controlId="floatingPhone" label="Teléfono">
              <Form.Control
                type=""
                placeholder="Teléfono"
                value={userData.telefono}
                onChange={(e)=>{
                  setUserData({
                    ...userData,
                    telefono: e.target.value
                  })
                }}
                required
              />
              <Form.Control.Feedback type="invalid">
                Debe ingresar un telefono.
              </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group> */}
        </Row>
        {!user.isSeller && 
          <>
            <hr></hr>
            <h3 className="mb-3">Datos de Envío</h3>
            <ShippingData shippingData={shippingData} setShippingData={setShippingData} />
          </>
        }
        <div className="btn-content my-3">
          <Button type='submit' variant="third" disabled={loading}>Guardar</Button>
        </div>
      </Form>
    </div>
  )
}